import invoiceFrag from "./Invoice";
import PayType from "./PayType";

const Payment = ({ payType = false, ...invoiceProps } = {}) => `
  id
  amount
  date
  exchange
  ref
  ${
    invoiceProps
      ? `invoice {
      ${invoiceFrag(invoiceProps)}
    }`
      : ""
  }
  invoiceId
  notes
  ${
    payType
      ? `type {
      ${PayType}
    }`
      : ""
  }
  typeId
`;

export default Payment;
